import { ref } from 'vue';
import { EN_SPACE_TYPE } from '../enums/spaceTypeEnum';
import { esHelper, IFindByConditionResponse, IPermission } from '/@/utils/http/es_utils/es_helper';
import { isPersonalApp } from '/@/utils/tenantHelper';
import { router } from '/@/router';
import WebStorage from '/@/utils/cache';
import { TENANT_ID, TENANT_CONFIG_ID } from '/@/enums/cacheEnum';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IEnterpriseInfo {}

export const enterpriseInfo = ref<IFindByConditionResponse & IEnterpriseInfo>();
const myRole = ref<IPermission>({} as unknown as IPermission);

export const useEnterpriseSpace = () => {
  return {
    enterpriseInfo,
    createEnterpriseSpace,
  };
};

export const createEnterpriseSpace = async (bForce = false) => {
  const curTenantId = WebStorage.get(TENANT_ID);
  if (!enterpriseInfo.value || bForce) {
    const res = await esHelper.findByCondition<IEnterpriseInfo>({
      includeAllChildren: false,
      force: true,
      props: {
        spaceType: EN_SPACE_TYPE.企业空间,
        spaceRelTenantId: isPersonalApp() ? '3' : curTenantId,
      },
      tags: ['space'],
      // userId: userStore.getUserInfo.id as string,
    });
    if (res.result.length >= 1) {
      const aa: any = { ...res.result[0] };
      if (!aa.permission) {
        aa.permission = { level: 1000 };
      }
      enterpriseInfo.value = { ...aa } as any;
      myRole.value = enterpriseInfo.value?.permission ?? ({ level: 1000 } as any);

      WebStorage.set(TENANT_CONFIG_ID, enterpriseInfo.value?.id ?? '');
    }
  }
};
